import { Color } from '@tmh-website/shared/colors';
import StyledGlobal from '@tmh-website/styles/global';
import StyledTypo from '@tmh-website/styles/typo';
import { StyledButton } from '@tmh-website/ui/Button';
import { getScrollbarStylingCss } from '@tmh-website/ui/Scrollbar';
import transparentize from 'polished/lib/color/transparentize';
import styled from 'styled-components';

export const Wrapper = styled(StyledGlobal.Wrapper)`
  width: auto;
  width: 408px;
  max-width: 100%;
  padding: 24px;
`;

export const TitleContainer = styled.div`
  ${StyledTypo.h5Css};
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const GrandTotal = styled.div`
  margin-left: auto;
`;

export const EmptyState = styled.div`
  padding: 24px 0;
  text-align: center;
`;

export const EmptyStateHeader = styled(StyledTypo.Typography)`
  margin: 24px 0 32px;
  opacity: 0.4;
`;

export const ItemListContainer = styled.div`
  position: relative;
`;

export const ItemList = styled.ol`
  max-height: min(400px, calc(100vh - 300px)); // TODO properly set value to prevent mobile overflow
  padding: 0;
  margin: 0;
  overflow-y: auto;
  list-style: none;
  ${getScrollbarStylingCss(Color.Neutral_200_OffWhite)};
`;

export const ItemListFade = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  pointer-events: none;
  background: linear-gradient(
    to top,
    ${props => transparentize(1, props.theme.color[Color.Neutral_200_OffWhite])} 20%,
    ${props => props.theme.color[Color.Neutral_200_OffWhite]} 100%
  );
  @media (${props => props.theme.breakpoint.sm.up}) {
    top: auto;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      ${props => transparentize(1, props.theme.color[Color.Neutral_200_OffWhite])} 20%,
      ${props => props.theme.color[Color.Neutral_200_OffWhite]} 100%
    );
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.gap.xSmall};
  align-items: stretch;
  margin-top: 8px;
`;
